import $ from 'jquery';
import { addAdminLoginAnnouncement } from '../../announcements';
import { checkOrgStatus } from '~src/utils';
import { initAnnunciFunebri } from '~src/sidebar/annunciFunebri/initAnnunciFunebri';
import {
  isLoggedUserGlobalEditor,
  isLoggedUserSuperUser,
  isUserAuthorized,
  getUser,
} from '~src/user';
import { initSidebarProfile } from '../../sidebar-profile';
import { addOrgDataToNavbar } from '../../navbar';
import { initAnalytics } from '~src/tracking';
import { initBrowsersManagement } from '~src/initBrowsersManagement';
import initReferralLinks from '~src/referral/initReferralLinks';
import { initNovita } from '~src/novita';
import {
  bindHelpIdentifyListener,
  getGuideTopicForPath,
  initGuideUi,
} from '~src/guide';
import { NOVITA_EMBED_SOURCE } from '~src/guide/config';

export const commonMiddleware = async ({ accessStatusPage = false } = {}) => {
  const allowed = await checkOrgStatus({ redirect: !accessStatusPage });
  if (!allowed && !accessStatusPage) return false;

  const isGlobalEditor = await isLoggedUserGlobalEditor();
  if (isGlobalEditor) {
    addAdminLoginAnnouncement();
  }

  initBrowsersManagement();

  await initAnalytics();
  await isUserAuthorized();
  await addOrgDataToNavbar();
  await initAnnunciFunebri();
  await initReferralLinks();
  // Customer support (super user) ed editor admin: nessuna chiamata/query
  // novità, per non disturbarli e non "sporcare" i dati. Nascondiamo anche
  // il launcher così non resta un bottone inerte in navbar.
  const isSuperUser = await isLoggedUserSuperUser();
  if (isGlobalEditor || isSuperUser) {
    $('[data-novita-launcher]').closest('li').hide();
  } else {
    initNovita().catch((error) => {
      console.warn('[novita] init failed', error);
    });
  }
  // Il pannello Guide non ha stato lato server: basta legare i launcher.
  initGuideUi();
  bindHelpIdentifyListener(getUser, (source) => ({
    topicSlug:
      source === NOVITA_EMBED_SOURCE
        ? 'novita'
        : getGuideTopicForPath(window.location.pathname),
    pathname: window.location.pathname,
  }));

  // Chat is handled by Gleap via initAnalytics.

  initSidebarProfile();

  $('.editor-route').hide();
  $('#firstLoader').remove();

  $('body').removeClass('canvas-route');

  $('#navbar-private').show();
  $('#navbar-canvas').hide();

  $('#navbar-private-button-back').hide();
  $('.logo').show();
  return true;
};
